var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal-dialog" }, [
    _c("div", { staticClass: "modal-content" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "modal-body" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.location.id,
              expression: "location.id",
            },
          ],
          attrs: { hidden: "", name: "location_id" },
          domProps: { value: _vm.location.id },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.location, "id", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _c(
          "p",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.location.location_name,
                expression: "location.location_name",
              },
            ],
          },
          [
            _vm._v(
              "\n        『" +
                _vm._s(_vm.location.location_name) +
                "』を削除してもよろしいですか？\n      "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "p",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.location.location_name,
                expression: "!location.location_name",
              },
            ],
          },
          [
            _vm._v(
              "\n        該当の拠点情報を削除してもよろしいですか？\n      "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-footer" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-default pull-left",
            attrs: { type: "button", "data-dismiss": "modal" },
          },
          [_vm._v("\n        キャンセル\n      ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.emitDeleteEvent(_vm.location_index, _vm.modal_id)
              },
            },
          },
          [_vm._v("\n        実行する\n      ")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close",
          },
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      ),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-trash modal-icon" }),
      _vm._v(" "),
      _c("h4", { staticClass: "modal-title" }, [_vm._v("削除の確認")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }